import React, { ReactElement } from 'react';
import { EmptyContainer } from '../empty/EmptyContainer';
import { Box } from '@material-ui/core';

type DataContainerProps = {
  children: ReactElement;
  isLoading?: boolean;
  isSuccess?: boolean;
  isEmpty?: boolean;
  emptyMessage?: string;
};

export const DataContainer = ({
  children,
  isLoading,
  isSuccess,
  isEmpty,
  emptyMessage,
}: DataContainerProps): ReactElement => {
  if (isSuccess && !isEmpty) {
    return (
      <Box display={'flex'} width={'100%'}>
        {children}
      </Box>
    );
  }
  return (
    <Box display={'flex'} justifyContent={'center'} width={'100%'}>
      <EmptyContainer loading={isLoading} emptyMessage={emptyMessage} />
    </Box>
  );
};
